import InputRadioDialog from "./src/InputRadioDialog";

export default InputRadioDialog